import { Component, Inject, Optional } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-lower-target-buffer-modal",
  templateUrl: "./lower-target-buffer-modal.component.html",
  styleUrls: ["./lower-target-buffer-modal.component.scss"],
  imports: [
    MatDialogModule,
    TranslateModule
  ],
  standalone: true
})
export class LowerTargetBufferModalComponent {
  local_data: boolean;

  constructor(
    public dialogRef: MatDialogRef<LowerTargetBufferModalComponent>,
    //@Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: boolean,
  ) {
    this.local_data = data;
  }
}
